
import React from 'react';

const Card = ({ children, className = '', hover = false, ...props }) => {
  const hoverClass = hover ? 'hover:shadow-lg transform hover:-translate-y-1 transition-all duration-200' : '';

  return (
    <div
      className={`bg-white rounded-lg shadow-md p-6 ${hoverClass} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;
